import newDate from './newDate'

// 本月
export function getCountDays() {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var d = new Date(year, month, 0)
    var dayCounts = d.getDate()

    var arr = []
    for (var i = 0; i <= dayCounts - 1; i++) {
        if (i < 10) {
            if (Number(month) < 10) {
                arr.push(String("0" + month + "-" + "0" + (i + 1)))
            } else {
                arr.push(String("0" + month + "-" + "0" + (i + 1)))
            }

        } else {
            if (Number(month) < 10) {
                arr.push(String("0" + month + "-" + (i + 1)))
            } else {
                arr.push(String(month + "-" + (i + 1)))
            }

        }
    }
    return arr
}

// 下月
export function getnextCountDays() {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 2
    var d = new Date(year, month, 0)
    var dayCounts = d.getDate()

    var arr = []
    for (var i = 0; i <= dayCounts - 1; i++) {
        if (i < 10) {
            if (Number(month) < 10) {
                arr.push(String("0" + month + "-" + "0" + (i + 1)))
            } else {
                arr.push(String("0" + month + "-" + "0" + (i + 1)))
            }

        } else {
            if (Number(month) < 10) {
                arr.push(String("0" + month + "-" + (i + 1)))
            } else {
                arr.push(String(month + "-" + (i + 1)))
            }

        }
    }
    return arr
}

// 上月
export function getagoCountDays() {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() 
    var d = new Date(year, month, 0)
    var dayCounts = d.getDate()

    var arr = []
    for (var i = 0; i <= dayCounts - 1; i++) {
        if (i < 10) {
            if (Number(month) < 10) {
                arr.push(String("0" + month + "-" + "0" + (i + 1)))
            } else {
                arr.push(String("0" + month + "-" + "0" + (i + 1)))
            }

        } else {
            if (Number(month) < 10) {
                arr.push(String("0" + month + "-" + (i + 1)))
            } else {
                arr.push(String(month + "-" + (i + 1)))
            }

        }
    }
    return arr
}

// 本周
export function getweek() {
    var now = new Date()
    
    
    
    // console.log(weekarr)
    // return weekarr
    
    // let weekDay = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];       let new_Date = new Date()
    
    //代码优化
    let timesStamp = now.getTime();       let currenDay = now.getDay();       let dates = [];       
    for(let i = 0; i < 7; i++) {       
    let myDate = new Date(Date.parse(new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString().replace(/[年月]/g, '-').replace(/[日上下午]/g, '-')));
        dates.push(    
                dateToString_month(new Date(new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString().replace(/[年月]/g, '-').replace(/[日上下午]/g, '-')))   
                    // label: new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString().replace(/[年月]/g, '-').replace(/[日上下午]/g, '') + weekDay[myDate.getDay()],           
        );
    }
    // console.log(dates)   
    return dates
}

//上周
export function getagoweek() {
    

    //代码优化
    //获取上周的时间节点
    
    var startDate = new Date(getagoweekstartend()[0])
    var endDate = new Date(getagoweekstartend()[1])
    // console.log(getagoweekstartend()
    // console.log("weekarr", weekarray)
    return getAllDateCN(startDate,endDate)
}

export function getagoweekstartend(Time = new Date()){
    let weekNum = Time.getDay();	//获取当前是周几
    weekNum = weekNum == 0 ? 7 : weekNum;
    let lastDate = new Date(Time.getTime() - weekNum * 24 * 60 * 60 * 1000);
    let fitstDate = new Date(Time.getTime() - ((weekNum + 6) * 24 * 60 * 60 * 1000));
    let startDate =
        `${fitstDate.getFullYear()}-${fitstDate.getMonth()+1<10?'0'+(fitstDate.getMonth()+1):fitstDate.getMonth()+1}-${fitstDate.getDate()<10?'0'+fitstDate.getDate():fitstDate.getDate()} 00:00:00`
    let endDate =
        `${lastDate.getFullYear()}-${lastDate.getMonth()+1<10?'0'+(lastDate.getMonth()+1):lastDate.getMonth()+1}-${lastDate.getDate()<10?'0'+lastDate.getDate():lastDate.getDate()} 23:59:59`
    return [startDate, endDate]
}

// 下周
export function getnextweek() {
    var now = new Date(); // 当前日期
    var nowDayOfWeek = now.getDay(); // 今天本周的第几天
    var nowDay = now.getDate();    // 当前日期
    var nowMonth = now.getMonth(); // 当前月
    var nowYear = now.getYear();   // 当前年
    nowYear += (nowYear < 2000) ? 1900 : 0; 
// console.log(getTime(-7));

    var startDate = new Date(getTime(-7))
    var endDate = new Date(getTime(-13))
    if(nowDayOfWeek == 0){
        startDate = new Date(nowYear, nowMonth, nowDay + 1);
        
        endDate = new Date(nowYear, nowMonth, nowDay + 7);
    }
    return getAllDateCN(startDate,endDate)
    // console.log("weekarr", weekarray)
}

export function getTime(n){
    var now=new Date();
    var year=now.getFullYear();
    //因为月份是从0开始的,所以获取这个月的月份数要加1才行
    var month=now.getMonth()+1;
    var date=now.getDate();
    var day=now.getDay();
    // console.log(day);
    //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
    if(day!==0){
        n=n+(day-1);
    }
    else{
        n=n+day;
    }
    if(day){
    //这个判断是为了解决跨年的问题
        if(month>1){
            month=month;
        }
        //这个判断是为了解决跨年的问题,月份是从0开始的
        else{
            year=year-1;
            month=12;
        }
    }
    now.setDate(now.getDate()-n);
    year=now.getFullYear();
    month=now.getMonth()+1;
    date=now.getDate();
    // console.log(n);
    var s=year+"-"+(month<10?('0'+month):month)+"-"+(date<10?('0'+date):date)+"";
    return s;
}
/***参数都是以周一为基准的***/
//上周的开始时间
// console.log(getTime(7));
//上周的结束时间
// console.log(getTime(1));
//本周的开始时间
// console.log(getTime(0));
//本周的结束时间
// console.log(getTime(-6));
//下周的开始时间
// console.log(getTime(-7));
//下周结束时间
// console.log(getTime(-13));

//获取当天的时间
export function getToday() { 
	var date = new Date();
	return date .getFullYear() + "-" + (date .getMonth()+1) + "-" +  date .getDate() ;
}

/** 
* 获得相对当月AddMonthCount个月的起止日期 
* AddMonthCount为0 代表当月 为-1代表上一个月 为1代表下一个月 以此类推
* ***/ 
export function getMonthStartAndEnd(AddMonthCount) { 
	//起止日期数组  
	var startStop = new Array(); 
	//获取当前时间  
	var currentDate = new Date();
	var month=currentDate.getMonth()+AddMonthCount;
	if(month<0){
	  var n = parseInt((-month)/12);
	  month += n*12;
	  currentDate.setFullYear(currentDate.getFullYear()-n);
	}
	currentDate = new Date(currentDate.setMonth(month));
	//获得当前月份0-11  
	var currentMonth = currentDate.getMonth(); 
	//获得当前年份4位年  
	var currentYear = currentDate.getFullYear(); 
	//获得上一个月的第一天  
	var currentMonthFirstDay = new Date(currentYear, currentMonth,1); 
	//获得上一月的最后一天  
	var currentMonthLastDay = new Date(currentYear, currentMonth+1, 0); 
	//添加至数组  
	startStop.push(getDateStr3(currentMonthFirstDay)); 
	startStop.push(getDateStr3(currentMonthLastDay)); 
	//返回  
	return startStop; 
}


//获取当前日期yy-mm-dd
//date 为时间对象
export function getDateStr3(date) {
	var year = "";
	var month = "";
	var day = "";
	var now = date;
	year = ""+now.getFullYear();
	if((now.getMonth()+1)<10){
	  month = "0"+(now.getMonth()+1);
	}else{
	  month = ""+(now.getMonth()+1);
	}
	if((now.getDate())<10){
	  day = "0"+(now.getDate());
	}else{
	  day = ""+(now.getDate());
	}
	return year+"-"+month+"-"+day;
}

//获取两个时间节点的数组
export function getAllDateCN(startTime, endTime) {
    var date_all = []
    var i = 0
    while ((endTime.getTime() - startTime.getTime()) >= 0) {
      var year = startTime.getFullYear()
      var month = startTime.getMonth() + 1
      var day = startTime.getDate()
      date_all[i] = dateToString_month(new Date(month + '-' + day + ''))
      startTime.setDate(startTime.getDate() + 1)
      i += 1
    }
    return date_all
  }

  //时间转化星期
  export function convertToChinese(num){
    var N = [
      "日", "一", "二", "三", "四", "五", "六"
    ];
    var str = num.toString();
    var len = num.toString().length;
    var C_Num = [];
    for(var i = 0; i < len; i++){
        C_Num.push(N[str.charAt(i)]);
    }
    return C_Num.join('');
  }


   //获取一周的时间
   //目前根据时间查询排班详情
   export function getWeekDateList(date){
    var now = date
    var nowTime = now.getTime() ; 
    var day = now.getDay();
    var oneDayLong = 24*60*60*1000 ; 
    
    var MondayTime = nowTime - (day-1)*oneDayLong  ; 
    var SundayTime =  nowTime + (7-day)*oneDayLong ; 

    var monday = new Date(MondayTime);
    var sunday = new Date(SundayTime);
    return [monday,sunday];
   }

   //工作年限计算
    export function dateSubMonth(date,numType) {
        var date1 = new Date(date);
        var date2 = new Date();
        var monthCount = parseInt(date2.getFullYear() - date1.getFullYear()) * 12 - date1.getMonth() + date2.getMonth();
        var resM = monthCount % 12;
        var resY = parseInt(monthCount / 12);
        var resStr = "";
        if(!numType){
            if (resY != 0) {
                resStr += resY + "年"
            }
            if (resM != 0) {
                resStr += resM + "个月"
            }
            if (resStr == "") {
                resStr = "0";
            }
        }else{
            resStr = resY
        }
        
        return resStr;
    }

    //时间格式化
    export function ConvertDate(oldtime){
        // 时间转换
        if(!oldtime) return '';
        var datejson = new Date(oldtime).toJSON();        
        var date = new Date( + new Date(datejson) 
                            + 8*3600*1000).toISOString().
                            replace(/T/g,' ').
                            replace(/\.[\d]{3}Z/,'')  
        return date;
    }

    //时间转换年月
    export function ConvertDateYM(date){
        if(!date) return '';
        date = new Date(Date.parse(date.replace(/-/g, "/").replace('T', ' '))); //转换成Data();
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;       
        return y + '-' + m;
    }

    /**
     * 日期格式化
     * @param {*} formatStr 'yyyy-MM-dd HH:mm:ss'
     * @param {*} date 
     */
    export function formatDate(formatStr, date) {
        if(!date) return '';
        date = new Date(Date.parse(date.replace(/-/g, "/").replace('T', ' '))); //转换成Data();
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;        
        return y + '-' + m + '-' + d;
    }




   
   